import { isIpad } from 'utils/util';

define(['jquery'], function($) {
     return  {
         init: function(bpDefinition) {
             // copy over jQuery elements already saved in brandplay.js
             for(i in bpDefinition) {
                 if(bpDefinition[i] instanceof $) this[i] = bpDefinition[i];
             }
             this.$pageWrapper.prepend("<div id='menuBG'>");
             this.bpDefinition = bpDefinition;
             this.$menuClose = $('#menu-close');
             this.$menuBG = $('#menuBG').hide();
             this.$programClose = $('#programClose');
             this.$playlistContainer = $('.playlistContainer');
             this.$program_menu__icons = $('.program_menu__icons');
             // if config does not have mobileMenu property, hide chapterMenu
             if(!bpInstance.mobileMenu) {
                 this.$program_menu__icons.addClass('no-menu');
             }
             this.build();
         },
         build: function() {
             // hide back arrow in app view, remove link from Medscape logo
             if($('body').hasClass('app')) {
                 let homeLink = $('#returnToMedscape');
                 homeLink.find('a').on('click', () => { return false;});
             }
             this.addHandlers();
         },
         addHandlers: function() {
             var self = this, menuOpenClass = 'open';
             $(window)
                 .on('mobmenu:close', (e) => {
                    e.preventDefault();
                    if(self.$playlistContainer.hasClass(menuOpenClass)) {
                        self.$menuBG.fadeOut(300);
                        self.$playlistContainer.removeClass(menuOpenClass);
                        $('body').removeClass('chapter-menu-open');

                        $(window).trigger('player:play');
                    } else {
                        self.$menuBG.fadeIn(300);
                        self.$playlistContainer.addClass(menuOpenClass);
                        if(self.$menuDropDown.hasClass(menuOpenClass)) {
                            self.$menuDropDown
                                .hide()
                                .removeClass('open');
                        }
                      $('body').addClass('chapter-menu-open');
                        $(window).trigger('player:pause');
                    }
                });

             this.$chapterMenu.on('click', () => {
                 $(window).trigger('mobmenu:close');
             });

             this.$menu.on('click', () => {
                 // Fix for PPE-49675
                 self.$brandPlay.removeClass('lock-isi');
                 self.$isiContainer.removeClass('lock-isi');
                 if (self.$menuDropDown.hasClass('open')) {
                     //re-add the native video controls when the layer is dismissed
                     self.$video
                         .attr('controls', 'true')
                         .removeClass('tempHideVideo');
                     self.$menuDropDown
                         .hide()
                         .removeClass('open');
                     self.$menuBG.fadeOut(300);
                     self.bpDefinition.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_close', self.bpDefinition]);
                 } else {
                     if(self.$playlistContainer.hasClass(menuOpenClass)) {
                         self.$playlistContainer.removeClass(menuOpenClass);
                     }
                     self.$menuBG.fadeIn(300);
                     self.$menuDropDown
                         .show()
                         .addClass('open');
                     self.bpDefinition.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_OPEN', 'vidvbp-action_sheet', self.bpDefinition]);
                     setTimeout(function() {
                         //remove native video controls while the menu layer is up
                         self.$video.removeAttr('controls');
                     }, 500);
                 }
             });

             this.$programClose.on('click', () => {
                 self.bpDefinition.notify('TrackBind', ['pamTrack', 'CLOSE', 'vidvbp-close', self.bpDefinition]);

                 var metaRefURL = $('meta[name=metaref]').attr('content');

                 if (metaRefURL !== 'null') {
                     if (metaRefURL.substring(0, 7) === 'http://') {
                         window.location.href = metaRefURL;
                     } else {
                         window.location.href = 'http://' + metaRefURL;
                     }
                 } else {
                     window.location.href = 'http://www.medscape.com';
                     // Handle click event.
                 }
             });

             this.$menuBG.add(this.$menuClose).on('click', (e) => {
                 $('body').removeClass('chapter-menu-open');
                 e.preventDefault();
                 self.$video
                     .attr('controls', 'true')
                     .removeClass('tempHideVideo');
                 self.$menu.removeClass('menu_open');
                 self.$menuDropDown
                     .hide()
                     .removeClass('open');
                 self.$menuBG.fadeOut(300);
                 self.$brandPlay.removeClass('lock-isi');
                 self.$isiContainer.removeClass('lock-isi');
                 if(self.$playlistContainer.hasClass(menuOpenClass)) self.$playlistContainer.removeClass(menuOpenClass);
                 if(self.$menuDropDown.hasClass(menuOpenClass)) self.$menuDropDown.removeClass(menuOpenClass);
             });

             this.$pageWrapper.on('click', () => {
                if(!isIpad()) {
                  self.$video
                      .attr('controls', 'true')
                      .removeClass('tempHideVideo');
                }
             });
         }
     };
 });



// WEBPACK FOOTER //
// ./modules/definitions/mobile_menu.js